import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-sommerfest-teaser',
  imports: [
    RouterLink,
    MatListModule,
    // MatButtonModule,
    // MatIconModule
  ],
  templateUrl: './sommerfest-teaser.component.html',
  styleUrl: './sommerfest-teaser.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SommerfestTeaserComponent {
  // Cutoff date: June 13th, 2026 at 23:59:59
  private readonly cutoffDate = new Date('2026-06-13T23:59:59');
  
  // Check if the component should be visible
  readonly shouldDisplay = computed(() => {
    const now = new Date();
    return now <= this.cutoffDate;
  });
}
